import { ISortOption, ISortResponse } from '../../types';

const mapSort = (sort: ISortResponse): ISortOption[] => {
  return sort.options.flatMap((option: ISortOption) => {
    const mappedSort: ISortOption = option;

    return mappedSort;
  })
}

export default mapSort;